/**
 * Lending Report API Service
 *
 * Domain-specific service for lending report endpoints.
 * Uses httpClient for automatic token rotation and error handling.
 */

import { httpClient } from './http-client.service';
import type {
    LendingReportResponse,
    LendingDecisionResponse,
    LendingDecisionSubmitResponse,
    LendingDecisionType,
} from '../types/lending-report.types';

class LendingReportAPIService {
    /**
     * Fetch the full lending report for a consent.
     */
    async getReport(consentId: string, batchId?: string): Promise<LendingReportResponse> {
        const payload: Record<string, string> = { consentId };
        if (batchId) payload.batchId = batchId;
        const response = await httpClient.post<LendingReportResponse>('lending/report', payload);
        return response.data;
    }

    /**
     * Submit an approve/reject decision.
     */
    async submitDecision(consentId: string, decision: LendingDecisionType): Promise<LendingDecisionSubmitResponse> {
        const response = await httpClient.post<LendingDecisionSubmitResponse>('lending/decision/submit', {
            consentId,
            decision,
        });
        return response.data;
    }

    /**
     * Fetch the existing decision for a consent.
     */
    async getDecision(consentId: string): Promise<LendingDecisionResponse> {
        const response = await httpClient.post<LendingDecisionResponse>('lending/decision', {
            consentId,
        });
        return response.data;
    }
}

export const lendingReportAPI = new LendingReportAPIService();
